import * as Yup from 'yup';
import {
  birthDateSchema,
  cpfSchema,
  emailSchema,
} from '~/validators/form/new_pix_link';

/**
 * Validação do checkout com carteira digital (Google Pay / Apple Pay).
 *
 * Espelha as regras de parcelas e dados de cobrança do checkout de cartão
 * (new_pix_link.js) sem os campos do cartão — o token da wallet substitui
 * número, validade, CVV e nome impresso. Mantido em arquivo próprio para
 * evoluir sem tocar no validador do cartão.
 */
const walletCheckoutSchema = maskTelephoneLength =>
  Yup.object().shape({
    installments: Yup.string().required('Insira o número de parcelas'),
    name: Yup.string().required('Insira seu nome'),
    telephone: Yup.string()
      .required('Insira seu telefone')
      .min(maskTelephoneLength, 'Insira todos os dígitos'),
    email: emailSchema,
    cpf: cpfSchema,
    birth_date: birthDateSchema,
    address: Yup.object().shape({
      cep: Yup.string()
        .required('Insira o CEP corretamente')
        .min(9, 'Insira todos os dígitos do CEP'),
      street_name: Yup.string().required('Insira o nome da rua'),
      number: Yup.string()
        .max(10, 'Número deve ter no máximo 10 caracteres')
        .required('Insira o número'),
      neighborhood: Yup.string().required('Insira o nome do bairro'),
      state: Yup.string().required('Selecione o estado'),
      city: Yup.string().required('Selecione a cidade'),
      complement: Yup.string()
        .notRequired()
        .max(128, 'Máximo de 128 caracteres'),
      additional_information: Yup.string()
        .notRequired()
        .max(
          128,
          'As informações adicionais devem ter no máximo 128 caracteres'
        ),
    }),
  });

export default walletCheckoutSchema;
